import type { ArticleDataObject, Tag } from "@app/types/Cue";
import LoadMore from "@components/LoadMore/LoadMore";
import { useLoadMoreStoriesByCategory } from "@hooks/useLoadMoreStoriesByCategory";

import PodcastsListingStories from "./PodcastsListingStories";

export type PodcastsOverviewProps = {
  articles: ArticleDataObject[];
  tag: Tag;
};

export default function PodcastsOverview({
  articles = [],
  tag,
}: PodcastsOverviewProps): React.ReactElement {
  const { articleList, handleLoadMore, hasMoreArticles } =
    useLoadMoreStoriesByCategory(tag.uri, "keywords", articles, 5);

  return (
    <section data-testid="podcasts-overview-component">
      <div className="stories">
        {articleList.map((article) => {
          return <PodcastsListingStories key={article.id} {...article} />;
        })}
      </div>

      {hasMoreArticles ? (
        <LoadMore
          rootClassName="my-4"
          onLoadMore={handleLoadMore}
          hasMore={hasMoreArticles}
        />
      ) : null}
    </section>
  );
}
